<div class="col-12 white-background common-border-radius">
    <app-bread-crumbs [breadCrumb]="breadCrumbArray"></app-bread-crumbs>
  <div class="col-12 menu-header page-buttons grid">
    <div class="col-12 title block-heading grid pl-4">
      <div (click)="backNavigate()" class="back-navigation-icon" title="Back"></div>
      <span translate>label_activity_logs</span>
    </div>
  </div>
  <div class="col-12">
    <div class="grid col-12">
    <div class="col-12 md:col-3 lg:col-3">
      <div class="form-label">
        <label for="startDate" translate>label_from_date</label>
      </div>
      <div class="form-control">
        <p-calendar [(ngModel)]="fromDate" [showIcon]="true" dateFormat="{{dateFormat}}" [readonlyInput]="true"></p-calendar>
      </div>
    </div>

    <div class="col-12 md:col-3 lg:col-3">
      <div class="form-label">
        <label for="toDate" translate>label_to_date</label>
      </div>
      <div class="form-control">
        <p-calendar [(ngModel)]="toDate" [showIcon]="true" [minDate]="fromDate" dateFormat="{{dateFormat}}" [readonlyInput]="true">
        </p-calendar>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-6 text-right">
      <div class="form-label">
        <label for="endtDate">&nbsp;</label>
      </div>
      <button class="filter-btn-apply" pButton appRipple (click)="changeFilter($event)" type="button" icon="fa fa-check"
        [label]="'label_apply' | translate"></button>
      <button class="reset-btn" pButton appRipple (click)="resetFilters()" type="button" icon="fa fa-undo"
        [label]="'label_reset' | translate"></button>
    </div>
  </div>
</div>
  <div class="col-12">
    <app-mi-grid-v2 [url]="url" bottomSearchBar="false" [columnDefs]="columns" rowSelection="multiple"
      divClass="mi-grid" [uniqId]="uniqId"></app-mi-grid-v2>
  </div>
</div>